// rr-voucher-auto — keeps the best campaign voucher code in the cart as the cart changes.
// Config comes from snippets/rr-voucher-auto.liquid (every enabled code + the member code).
//
// Only for shoppers who already have one of these codes in the cart (applied, or kept for later).
// After every change to the cart's items it sends all campaign codes at once; Shopify applies the
// best combination and flags the rest, and only the winners are kept. When nothing applies (cart
// dropped below every minimum) the shopper's codes are put back so they apply again later.
(() => {
  const conf = document.getElementById('rr-voucher-auto-config');
  if (!conf || window.__rrVoucherAuto) return;
  window.__rrVoucherAuto = true;

  let cfg;
  try {
    cfg = JSON.parse(conf.textContent);
  } catch (e) {
    return;
  }
  const codes = (cfg.codes || []).filter(Boolean);
  if (codes.length < 2) return;

  const TEXT = {
    th: 'เปลี่ยนเป็นโค้ด {code} ให้อัตโนมัติ ส่วนลดดีที่สุดสำหรับตะกร้านี้',
    en: 'Switched to code {code}, the best discount for your cart'
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SIG_KEY = 'rr-voucher-auto:sig';
  const same = (a, b) => String(a).toUpperCase() === String(b).toUpperCase();
  const isOurs = (c) => codes.some((x) => same(x, c));
  const allCodes = (cart) => ((cart && cart.discount_codes) || []).map((c) => c.code);
  const appliedCodes = (cart) => ((cart && cart.discount_codes) || []).filter((c) => c.applicable).map((c) => c.code);
  // What's in the cart, not what it costs: a discount-only update leaves this unchanged.
  // (Not the line key: Shopify changes it when the line's discount changes.)
  const signature = (cart) =>
    (cart.items || [])
      .map((i) => i.variant_id + ':' + i.quantity + ':' + (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : ''))
      .sort()
      .join(',');

  const json = (r) => {
    if (!r.ok) throw new Error('cart ' + r.status);
    return r.json();
  };
  const getCart = () => fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(json);
  const setDiscount = (discount) =>
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount })
    }).then(json);

  let lastSig = null;
  try {
    lastSig = sessionStorage.getItem(SIG_KEY);
  } catch (e) {}
  const remember = (sig) => {
    lastSig = sig;
    try {
      sessionStorage.setItem(SIG_KEY, sig);
    } catch (e) {}
  };

  let busy = false;
  let again = false;
  let timer = null;
  const schedule = (ms) => {
    clearTimeout(timer);
    timer = setTimeout(run, ms == null ? 400 : ms);
  };

  async function run() {
    if (cfg.end > 0 && cfg.end < Date.now() / 1000) return;
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      const before = await getCart();
      const sig = signature(before);
      if (sig === lastSig) return;
      remember(sig);
      const had = allCodes(before);
      if (!before.item_count || !had.some(isOurs)) return;

      // Every campaign code plus whatever else the shopper had: Shopify keeps the best combination.
      const tries = had.slice();
      codes.forEach((c) => !tries.some((x) => same(x, c)) && tries.push(c));
      let after = await setDiscount(tries.join(','));
      const won = appliedCodes(after);
      const keep = won.length ? won : had;
      if (keep.join(',') !== allCodes(after).join(',')) after = await setDiscount(keep.join(','));

      const oldCode = appliedCodes(before).find(isOurs);
      const newCode = appliedCodes(after).find(isOurs);
      const changed = allCodes(before).join(',') !== allCodes(after).join(',') || before.total_price !== after.total_price;
      if (changed) notify(after);
      if (newCode && !(oldCode && same(oldCode, newCode))) toast(newCode);
    } catch (e) {
      // Leave the cart as it is; the next cart change tries again.
    } finally {
      busy = false;
      if (again) {
        again = false;
        schedule();
      }
    }
  }

  // Let the cart UIs show the new code and total.
  function notify(cart) {
    try {
      if (window.KaiCartDrawer && typeof window.KaiCartDrawer.refresh === 'function') window.KaiCartDrawer.refresh();
    } catch (e) {}
    try {
      if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rr-voucher-auto', cartData: cart });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('rr:voucher:auto', { detail: { cart } }));
  }

  function toast(code) {
    const text = (TEXT[cfg.locale] || TEXT.th).replace('{code}', code);
    let el = document.getElementById('rr-voucher-auto-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'rr-voucher-auto-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translate(-50%,12px);z-index:2147483000;' +
        'max-width:min(92vw,420px);padding:12px 18px;border-radius:5px;background:#0B4062;color:#fff;' +
        'font-size:14px;line-height:1.45;text-align:center;box-shadow:0 6px 24px rgba(0,0,0,.18);' +
        'opacity:0;transition:opacity .25s,transform .25s;pointer-events:none';
      document.body.appendChild(el);
    }
    el.textContent = text;
    requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translate(-50%,0)';
    });
    clearTimeout(el._hide);
    el._hide = setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translate(-50%,12px)';
    }, 4000);
  }

  // Any cart write on the page (theme, Kai drawer, apps): read-only watch, nothing is patched.
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver((list) => {
        if (list.getEntries().some((e) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name))) schedule();
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  try {
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => (!e || e.source !== 'rr-voucher-auto') && schedule());
    }
  } catch (e) {}
  window.addEventListener('pageshow', () => schedule());
  // A change made just before the last page unloaded is caught on the next page.
  schedule(1200);
})();
